import { gql } from '@apollo/client';

export const GET_TWILIO_PHONE_TOKEN = gql`
  query {
    twilioCapabilityToken(type: Phone) {
      token
    }
  }
`;

export const GET_CLINIC_FINANCIAL_REPORT_SETTINGS = gql`
  query clinic($id: String!) {
    findUniqueClinic(where: { id: $id }) {
      clinicSetting {
        id
        financialReportingConfig
        paymentFeeConfig {
          feeCollection
        }
      }
    }
  }
`;

const FINANCIAL_TRANSACTIONS_FRAG = gql`
  fragment FinancialTransactionsSelection on FinancialTransaction {
    id
    createdAt
    updatedAt
    timestamp
    type
    stripePaymentIntent {
      id
      paymentIdentifier
      emailOverride
      createdAt
      updatedAt
      paidAt
      settledAt
      stripeId
      status
      amount
      amountCaptured
      serviceFeeAmount
      clinicServiceFeePercent
      clinicServiceFeeFlat
      clientServiceFee
      paymentMedium
      clientServiceFeePercent
      total
      transferType
      stripeRefunds {
        id
        total
        amount
      }
      stripePaymentMethod {
        id
        cardBrand
        last4
        type
        funding
      }
      clinicPetParent {
        id
        firstName
        lastName
        pimsId
        email
      }
      stripeTerminal {
        id
        name
        serialNumber
      }
      stripeReceipt {
        id
      }
      sentBy {
        id
        firstName
        lastName
        nameDisplay
      }
      invoices {
        id
        identifier
      }
      paymentRelationship
      writebackLogEntries {
        writebackLog {
          id
          pimsError
          normalizedError
          requestBody
          status
          createdAt
        }
      }
    }
    stripeRefund {
      id
      createdAt
      stripeId
      amount
      clinicFeeRefunded
      clientFeeRefunded
      total
      stripeReceipt {
        id
      }
      reason
      reasonOther
      issuedBy {
        id
      }
      stripePaymentIntent {
        amount
        clinicPetParent {
          id
          firstName
          lastName
          pimsId
        }
        stripePaymentMethod {
          id
          cardBrand
          last4
          type
        }
        invoices {
          identifier
        }
      }
      issuedBy {
        id
        firstName
        lastName
        nameDisplay
      }
    }
    stripeDispute {
      id
      createdAt
      stripeId
      amount
      disputeFee
      processingFeesRefunded
      status
      stripeTransferReversalId
      stripeDisputeFeeChargeId
      stripePaymentIntent {
        clinicPetParent {
          id
          firstName
          lastName
          pimsId
        }
        stripePaymentMethod {
          id
          cardBrand
          last4
          type
        }
        invoices {
          identifier
        }
      }
    }
    stripePayout {
      id
      createdAt
      updatedAt
      stripeId
      stripePaymentIntents {
        id
      }
      amount
      arrivalDate
      initiatedAt
      status
    }
    stripeInvoice {
      id
      paidAt
      amount
      status
      collectionMethod
      serviceFeeAmount
      serviceFeePercent
      stripeCustomer {
        id
        organizationPetParents {
          clinicPetParents {
            id
            clinicId
            firstName
            lastName
            pimsId
          }
        }
      }
      stripePaymentMethod {
        id
        cardBrand
        last4
        type
      }
      financialTransaction {
        stripePaymentIntent {
          stripeTerminal {
            id
            name
            serialNumber
          }
        }
      }
    }
    adjustment {
      id
      amount
      description
    }
    channel {
      id
    }
  }
`;

export const FINANCIAL_TRANSACTIONS = gql`
  query findManyFinancialTransaction($where: FinancialTransactionWhereInput!, $skip: Int, $take: Int) {
    findManyFinancialTransactionCount(where: $where)
    findManyFinancialTransaction(where: $where, orderBy: { timestamp: desc }, skip: $skip, take: $take) {
      ...FinancialTransactionsSelection
    }
  }
  ${FINANCIAL_TRANSACTIONS_FRAG}
`;

export const SEARCH_CLINIC_PET_PARENT = gql`
  query clinicPetParentSearch($whereInput: SearchClinicPetParentInput, $pageSize: Int) {
    clinicPetParentSearch(where: $whereInput, take: $pageSize) {
      id
      firstName
      lastName
      phoneNumber
      phoneNumbers {
        id
        number
      }
    }
  }
`;

export const FIND_UNIQUE_CALL_HISTORY = gql`
  query FindUniqueCallHistory($where: CallHistoryWhereUniqueInput!) {
    findUniqueCallHistory(where: $where) {
      id
    }
  }
`;
